import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import reportWebVitals from "../reportWebVitals";
import { TelemetryService } from "../services/TelemetryService";

function getDetailsProviderId(route, search) {
  if (route !== "/details") {
    return "";
  }

  const query = new URLSearchParams(search || "");
  return query.get("id") || "";
}

function getButtonData(target) {
  if (!target || !(target instanceof Element)) {
    return null;
  }

  const button = target.closest('button, [role="button"], input[type="button"], input[type="submit"], input[type="reset"]');
  if (!button) {
    return null;
  }

  const textSource = button.innerText || button.textContent || button.getAttribute("aria-label") || button.getAttribute("name") || "";
  const buttonText = textSource.trim().slice(0, 120) || "unlabeled";

  return {
    text: buttonText,
    id: (button.id || "").slice(0, 120) || "none",
    type: (button.getAttribute("type") || button.tagName || "unknown").toLowerCase(),
    classes: (button.className || "").toString().trim().slice(0, 200) || "none",
  };
}

export default function TelemetryTracker() {
  const location = useLocation();

  useEffect(() => {
    const route = location.pathname || "unknown_route";
    const providerId = getDetailsProviderId(route, location.search);

    TelemetryService.sendEvent({
      name: "page_view",
      route,
      page: route,
      status: "ok",
      tags: {
        query: location.search || "",
        provider_id: providerId,
      },
    });
  }, [location.pathname, location.search]);

  useEffect(() => {
    const handleClick = (event) => {
      const buttonData = getButtonData(event.target);
      if (!buttonData) {
        return;
      }

      const route = window.location.pathname || "unknown_route";
      const providerId = getDetailsProviderId(route, window.location.search);

      TelemetryService.sendEvent({
        name: "button_click",
        route,
        page: route,
        status: "ok",
        tags: {
          button_text: buttonData.text,
          button_id: buttonData.id,
          button_type: buttonData.type,
          button_classes: buttonData.classes,
          provider_id: providerId,
        },
      });
    };

    document.addEventListener("click", handleClick, true);
    return () => {
      document.removeEventListener("click", handleClick, true);
    };
  }, []);

  useEffect(() => {
    reportWebVitals((metric) => {
      const route = window.location.pathname || "unknown_route";
      const providerId = getDetailsProviderId(route, window.location.search);
      const status = metric.rating || "unknown";

      TelemetryService.sendEvent({
        name: `web_vital_${String(metric.name || "unknown").toLowerCase()}`,
        route,
        page: route,
        status,
        value: Number.isFinite(metric.value) ? Number(metric.value) : undefined,
        durationMs: Number.isFinite(metric.delta) ? Number(metric.delta) : undefined,
        tags: {
          metric_id: metric.id || "",
          navigation_type: metric.navigationType || "",
          provider_id: providerId,
        },
      });
    });
  }, []);

  return null;
}
